import { useState, useEffect } from "react";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useGetInteractions = ({leadID, pageSize, page}) => {
    const [lastInteraction, setLastInteraction] = useState(null)
    const [allInteractions, setAllInteractions] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchData = async() => {
        if (!leadID) return;
        setIsLoading(true)
        
        try{
            const queryParams = new URLSearchParams({
                page: page,
                page_size: pageSize,
                lead_id: leadID
            })
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_INTERACTIONS.LAST_INTERACTIONS}?${queryParams}`, 'GET')
            setLastInteraction(result)

            const allResult = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_INTERACTIONS.ALL_INTERACTIONS}?${queryParams}`)
            setAllInteractions(allResult)
        } catch (error) {
            console.error(error)
        }finally{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchData()
    }, [leadID, pageSize, page])
    return {lastInteraction, allInteractions, isLoading, refetch: fetchData}
}
